import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

import {translationNamespaces} from '@/common/enums';
import {firebaseClient} from '@/common/firebaseClient';
import ForgotPassword, {TForgotPasswordInputs} from '@/components/Registration/ForgotPassword';
import {useAuth} from '@/hooks/useAuth';

const Page = (): JSX.Element | null => {
  const {signOut} = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState<string>();
  const {t} = useTranslation(translationNamespaces.REGISTRATION);

  async function onSubmit(data: TForgotPasswordInputs) {
    setIsLoading(true);
    setError(undefined);
    try {
      await firebaseClient.auth().sendPasswordResetEmail(data.email);
      setIsSent(true);
      signOut();
    } catch (e) {
      setError(t('errors.undefined'));
    }
    setIsLoading(false);
  }

  return <ForgotPassword isLoading={isLoading} onSubmit={onSubmit} error={error} isSent={isSent} />;
};

export default Page;
